import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=24803528&scoped=true"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=24803528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24803528",
  null
  
)

export default component.exports